

define(['angular', 'squid/index', './directive', 'pages/xo-sidebar/route', 'components/xo-login-components/src/onetouch-interstitial/route', 'components/xo-guest-components/src/guest-upgrade-interstitial/route', 'components/xo-guest-components/src/guest/currencyConversion/route'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-guest.route', ['squid', 'hermes.page.xo-guest.directive', 'hermes.page.xo-sidebar.route']).factory('$GuestRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('GuestRoute', {
            name: 'guest',
            directive: 'xo-guest',
            titleContent: 'accountCreationGuest.heading',
            trackingData: {
                fptiState: 'guest_xo',
                trackStateExit: false,
                templateName: 'guest.dust',
                pageGoal: 'Payment Start',
                pageQualifier: 'guest',
                buzname: {
                    'guest': {
                        'pagename': '%::fullpage-guest',
                        'pagename2': '%::fullpage-guest:member:hermes:',
                        'version': 'guest:%:'
                    },
                    'signup': {
                        'pagename': '%::fullpage-guestSignup',
                        'pagename2': '%::fullpage-guestSignup:member:hermes:',
                        'version': 'guestSignup:%:'
                    }
                    // More page qualifiers come here...
                }
            },
            children: [{
                name: '$SidebarRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'singleStepModel'
                }
            }, {
                name: '$OneTouchUpsellRoute',
                attributes: {
                    token: 'token',
                    'on-complete': 'onComplete',
                    'disable-close-button': 'true',
                    'ignore-bg-clicks': 'true'
                }
            }, {
                name: '$GuestUpgradeInterstitialRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'singleStepModel'
                }
            }, {
                name: '$CurrencyConversionOptionsRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'singleStepModel',
                    'is-pre-plan': 'true',
                    'done-fn': 'onCurrencyConversionDone'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-guest/route.js
// module id = ./pages/xo-guest/route.js
// module chunks = 1